import { memo } from "react";
import { View } from "react-native";
import { GatheringHeaderProps } from "src/components/GatheringHeader/types";
import InfiniteCarousel from "src/components/InfiniteCarousel";
import { InfiniteCarouselProps } from "src/components/InfiniteCarousel/types";
import MiniCard, { MINI_CARD_HEIGHT, MINI_CARD_WIDTH } from "src/components/MiniCard";
import haptic from "src/helpers/haptic";
import { paddingLarge, paddingMedium } from "src/styles/spacing";

const animatedStyleWorklet: InfiniteCarouselProps<unknown>["animatedStyleWorklet"] = ({
	itemDim,
	index,
	indexDiff,
	animatedIndex,
	itemSpacing,
}) => {
	"worklet";
	return {
		transform: [
			{
				rotate: `${-0.07 * indexDiff}rad`,
			},
			{
				translateX: -(animatedIndex.value - index) * (itemDim.width + itemSpacing),
			},
			{
				translateY: -3 * Math.pow(Math.abs(indexDiff), 2),
			},
		],
	};
};

const GatheringHeaderRegularMiniCards = ({
	miniCards,
}: {
	miniCards: NonNullable<GatheringHeaderProps["miniCards"]>;
}) => {
	return (
		<View
			style={{
				width: "100%",
				maxWidth: "100%",
				overflow: "hidden",
				marginTop: paddingLarge,
				paddingBottom: paddingLarge,
			}}
		>
			<InfiniteCarousel
				data={miniCards}
				renderItem={({ item }) => <MiniCard {...item} />}
				autoPlay={false}
				itemSpacing={paddingMedium}
				itemDim={{
					width: MINI_CARD_WIDTH,
					height: MINI_CARD_HEIGHT,
				}}
				animatedStyleWorklet={animatedStyleWorklet}
				onItemFocused={() => {
					haptic("Light");
				}}
			/>
		</View>
	);
};
export default memo(GatheringHeaderRegularMiniCards);
